import { EmptyTemplateEngine } from './template_engine';
import { dashToCamelCase, initValues, updateValues } from './utils';
const getTmplArgs = (elem) => {
    const node = elem;
    // eslint-disable-next-line no-return-assign
    return (node._$wxTmplArgs = node._$wxTmplArgs || {});
};
export class Fragment {
    constructor() {
        this.childNodes = [];
    }
    appendChild(child) {
        this.childNodes.push(child);
    }
    destroyBackendElement() {
        // do nothing
    }
}
export class ViewController {
    // eslint-disable-next-line no-useless-constructor
    constructor(_glassEasel, _rootNode, _backendContext, _componentSpace) {
        this._glassEasel = _glassEasel;
        this._rootNode = _rootNode;
        this._backendContext = _backendContext;
        this._componentSpace = _componentSpace;
        // private _nodeMap: (Node | Fragment | undefined)[] = []
        this._listenerMap = new WeakMap();
        this._styleSheetIdMapping = Object.create(null);
        this._styleScopeIdMapping = [0];
        this._traceStartTimestampMapping = Object.create(null);
        //
    }
    create(initWindowSize) {
        const { _backendContext } = this;
        initWindowSize({
            windowInfo: {
                width: _backendContext.getWindowWidth(),
                height: _backendContext.getWindowHeight(),
                devicePixelRatio: _backendContext.getDevicePixelRatio(),
            },
            themeInfo: {
                theme: _backendContext.getTheme(),
            },
        });
    }
    destroy() {
        //
    }
    onWindowResize(cb) {
        var _a;
        const { _backendContext } = this;
        (_a = _backendContext.onWindowResize) === null || _a === void 0 ? void 0 : _a.call(_backendContext, cb);
    }
    onThemeChange(cb) {
        var _a;
        const { _backendContext } = this;
        (_a = _backendContext.onThemeChange) === null || _a === void 0 ? void 0 : _a.call(_backendContext, cb);
    }
    render(cb) {
        const { _backendContext } = this;
        _backendContext.render(cb);
    }
    createMediaQueryObserver(status, listener) {
        var _a;
        const { _backendContext } = this;
        return (_a = _backendContext.createMediaQueryObserver) === null || _a === void 0 ? void 0 : _a.call(_backendContext, status, listener);
    }
    createIntersectionObserver(target, relativeElement, relativeElementMargin, threshold, listener) {
        var _a;
        return ((_a = target.createIntersectionObserver(relativeElement, relativeElementMargin, threshold, listener)) !== null && _a !== void 0 ? _a : undefined);
    }
    createResizeObserver(target, mode, listener) {
        var _a;
        return (_a = target.createResizeObserver(mode, listener)) !== null && _a !== void 0 ? _a : undefined;
    }
    elementFromPoint(x, y, cb) {
        const { _backendContext } = this;
        if (!_backendContext.elementFromPoint) {
            cb(null);
            return;
        }
        _backendContext.elementFromPoint(x, y, cb);
    }
    createElement(logicalName, stylingName, ownerShadowRoot) {
        return ownerShadowRoot.createNativeNodeWithInit(logicalName, stylingName, undefined);
    }
    createElementOrComponent(logicalName, stylingName, ownerShadowRoot) {
        const comp = this.createExternalComponent(logicalName, stylingName, ownerShadowRoot);
        if (comp && typeof comp !== 'string')
            return comp;
        return this.createElement(comp || logicalName, stylingName, ownerShadowRoot);
    }
    createExternalComponent(logicalName, stylingName, ownerShadowRoot) {
        const { _glassEasel, _componentSpace, _backendContext, _dynamicSlotHandler } = this;
        // find in the space otherwise
        const compDef = _componentSpace.getGlobalUsingComponent(logicalName);
        if (typeof compDef === 'string' || !compDef) {
            return compDef;
        }
        const comp = ownerShadowRoot
            ? ownerShadowRoot.createComponentByDef(stylingName, compDef)
            : _glassEasel.Component.createWithContext(stylingName, compDef, _backendContext);
        const shadowRoot = comp.getShadowRoot();
        if (_dynamicSlotHandler && (shadowRoot === null || shadowRoot === void 0 ? void 0 : shadowRoot.getSlotMode()) === 3 /* _glassEasel.SlotMode.Dynamic */) {
            shadowRoot.setDynamicSlotHandler((slots) => _dynamicSlotHandler.insertSlotHandler(comp, slots), (slots) => _dynamicSlotHandler.removeSlotHandler(slots), (slot, slotValues) => {
                const tmplArgs = getTmplArgs(slot);
                _dynamicSlotHandler.updateSlotHandler(slot, slotValues, tmplArgs.dynamicSlotValueChangedNames || []);
                tmplArgs.dynamicSlotValueChangedNames = undefined;
            }, (slot, name) => {
                const tmplArgs = getTmplArgs(slot);
                tmplArgs.dynamicSlotValueChangedNames = tmplArgs.dynamicSlotValueChangedNames || [];
                tmplArgs.dynamicSlotValueChangedNames.push(name);
            });
            shadowRoot.applySlotUpdates();
        }
        return comp;
    }
    createSimpleComponent(tagName, ownerShadowRoot, virtualHost, styleScope, extraStyleScope, externalClasses, slotMode, writeIdToDOM, chainDefinition, cb) {
        const { _glassEasel, _backendContext } = this;
        this._$pendingAssignComponentId = (component) => {
            this._$pendingAssignComponentId = undefined;
            cb(component);
        };
        this._$pendingCreateSimpleComponent = (isReflect) => {
            var _a, _b, _c;
            this._$pendingCreateSimpleComponent = undefined;
            if (isReflect) {
                const comp = this.createExternalComponent(tagName, tagName, ownerShadowRoot);
                if (comp && typeof comp !== 'string')
                    return (_a = this._$pendingAssignComponentId) === null || _a === void 0 ? void 0 : _a.call(this, comp);
            }
            const actualStyleScope = (_b = (styleScope !== undefined ? this._styleScopeIdMapping[styleScope] : undefined)) !== null && _b !== void 0 ? _b : _glassEasel.StyleScopeManager.globalScope();
            const actualExtraStyleScope = extraStyleScope !== null ? this._styleScopeIdMapping[extraStyleScope] : undefined;
            const componentSpace = this._componentSpace;
            const compDefBuilder = componentSpace.define().definition({
                options: {
                    // externalComponent: external,
                    multipleSlots: slotMode === 2 /* _glassEasel.SlotMode.Multiple */,
                    dynamicSlots: slotMode === 3 /* _glassEasel.SlotMode.Dynamic */,
                    virtualHost,
                    styleScope: actualStyleScope,
                    extraStyleScope: actualExtraStyleScope,
                    writeIdToDOM,
                    templateEngine: EmptyTemplateEngine,
                },
                externalClasses,
            });
            const compDef = (chainDefinition ? chainDefinition(compDefBuilder) : compDefBuilder).registerComponent();
            const node = ownerShadowRoot
                ? ownerShadowRoot.createComponentByDef(tagName, compDef)
                : _glassEasel.Component.createWithContext(tagName, compDef, _backendContext);
            return (_c = this._$pendingAssignComponentId) === null || _c === void 0 ? void 0 : _c.call(this, node);
        };
    }
    createTextNode(textContent, ownerShadowRoot) {
        return ownerShadowRoot.createTextNode(textContent);
    }
    createVirtualNode(virtualName, ownerShadowRoot) {
        return ownerShadowRoot.createVirtualNode(virtualName);
    }
    createShadowRoot(hostNode) {
        return hostNode.shadowRoot;
    }
    createFragment() {
        return new Fragment();
    }
    release(node) {
        node.destroyBackendElement();
    }
    appendChild(parent, child) {
        if (parent) {
            parent.appendChild(child);
        }
        else {
            const { _rootNode, _glassEasel } = this;
            _rootNode.appendChild(child.getBackendElement());
            _glassEasel.Element.pretendAttached(child);
        }
    }
    removeChild(parent, child) {
        if (parent) {
            parent.removeChild(child);
        }
        else {
            const { _rootNode, _glassEasel } = this;
            _rootNode.removeChild(child.getBackendElement());
            _glassEasel.Element.pretendDetached(child);
        }
    }
    insertBefore(parent, child, before) {
        if (parent) {
            parent.insertBefore(child, before);
        }
        else {
            const { _rootNode, _glassEasel } = this;
            _rootNode.insertBefore(child.getBackendElement(), before.getBackendElement());
            _glassEasel.Element.pretendAttached(child);
        }
    }
    replaceChild(parent, child, oldChild) {
        if (parent) {
            parent.replaceChild(child, oldChild);
        }
        else {
            const { _rootNode, _glassEasel } = this;
            _rootNode.replaceChild(child.getBackendElement(), oldChild.getBackendElement());
            _glassEasel.Element.pretendDetached(oldChild);
            _glassEasel.Element.pretendAttached(child);
        }
    }
    spliceBefore(parent, before, deleteCount, list) {
        const index = before.parentIndex;
        if (deleteCount)
            parent.removeChildren(index, deleteCount);
        if (list.childNodes.length)
            parent.insertChildren(list.childNodes, index);
        list.childNodes = [];
    }
    spliceAppend(parent, list) {
        parent.insertChildren(list.childNodes, -1);
        list.childNodes = [];
    }
    spliceRemove(parent, start, deleteCount) {
        parent.removeChildren(start.parentIndex, deleteCount);
    }
    associateValue(node, data) {
        var _a;
        (_a = this._$pendingCreateSimpleComponent) === null || _a === void 0 ? void 0 : _a.call(this, data.isReflect);
    }
    setId(element, id) {
        element.id = id;
    }
    setSlot(element, name) {
        element.slot = name;
    }
    setSlotName(element, name) {
        const { _glassEasel } = this;
        _glassEasel.Element.setSlotName(element, name);
    }
    setSlotElement(node, slot) {
        const { _glassEasel } = this;
        _glassEasel.Element.setSlotElement(node, slot);
    }
    setInheritSlots(element) {
        const { _glassEasel } = this;
        _glassEasel.Element.setInheritSlots(element);
    }
    registerStyleScope(scopeId, stylePrefix) {
        const { _componentSpace } = this;
        const styleScopeManager = _componentSpace.styleScopeManager;
        const actualScopeId = styleScopeManager.register(stylePrefix || '');
        this._styleScopeIdMapping[scopeId] = actualScopeId;
    }
    setStyle(element, styleText, styleSegmentIndex) {
        element.setNodeStyle(styleText, styleSegmentIndex);
    }
    addClass(element, className) {
        element.classList.toggle(className, true);
    }
    removeClass(element, className) {
        element.classList.toggle(className, false);
    }
    setClassAlias(element, className, target) {
        element.setExternalClass(className, target);
    }
    setAttribute(element, name, value) {
        const { _glassEasel } = this;
        const Component = _glassEasel.Component;
        if (Component.isComponent(element)) {
            const camelName = dashToCamelCase(name);
            const dataProxy = Component.getDataProxy(element);
            if (dataProxy.replaceProperty(camelName, value)) {
                dataProxy.applyDataUpdates(true);
                return;
            }
            if (element.hasExternalClass(name)) {
                element.setExternalClass(name, value);
                return;
            }
        }
        element.updateAttribute(name, value);
    }
    removeAttribute(element, name) {
        const { _glassEasel } = this;
        const Component = _glassEasel.Component;
        if (Component.isComponent(element)) {
            const camelName = dashToCamelCase(name);
            const dataProxy = Component.getDataProxy(element);
            if (dataProxy.replaceProperty(camelName, undefined)) {
                dataProxy.applyDataUpdates(true);
                return;
            }
            if (element.hasExternalClass(name)) {
                element.setExternalClass(name, '');
                return;
            }
        }
        element.removeAttribute(name);
    }
    setDataset(element, name, value) {
        element.setDataset(name, value);
    }
    setText(textNode, textContent) {
        textNode.textContent = textContent;
    }
    setModelBindingStat(element, attributeName, listener) {
        const { _glassEasel } = this;
        if (_glassEasel.Component.isComponent(element)) {
            const nodeDataProxy = _glassEasel.Component.getDataProxy(element);
            nodeDataProxy.setModelBindingListener(attributeName, listener);
        }
        else if (_glassEasel.NativeNode.isNativeNode(element)) {
            element.setModelBindingListener(attributeName, listener);
        }
    }
    callSuggestedBackendMethod(element, method, args) {
        const { _glassEasel } = this;
        const backendContext = element.getBackendContext();
        const backendElement = element.getBackendElement();
        if (!backendContext || !backendElement) {
            return;
        }
        if (backendContext.mode === 3 /* _glassEasel.BackendMode.Domlike */) {
            if (!backendContext[method]) {
                return;
            }
            ;
            backendContext[method](backendElement, ...args);
        }
        else {
            const be = backendElement;
            if (!be[method]) {
                return;
            }
            ;
            be[method](...args);
        }
    }
    callSuggestedBackendCbMethod(element, method, args, defaultReturn, cb) {
        const { _glassEasel } = this;
        const backendContext = element.getBackendContext();
        const backendElement = element.getBackendElement();
        if (!backendContext || !backendElement) {
            return cb(defaultReturn);
        }
        if (backendContext.mode === 3 /* _glassEasel.BackendMode.Domlike */) {
            if (!backendContext[method]) {
                return cb(defaultReturn);
            }
            ;
            backendContext[method](backendElement, ...args, cb);
        }
        else {
            const be = backendElement;
            if (!be[method]) {
                return cb(defaultReturn);
            }
            ;
            be[method](...args, cb);
        }
    }
    getAllComputedStyles(element, cb) {
        this.callSuggestedBackendCbMethod(element, 'getAllComputedStyles', [], { properties: [] }, cb);
    }
    getPseudoComputedStyles(element, pseudoType, cb) {
        this.callSuggestedBackendCbMethod(element, 'getPseudoComputedStyles', [pseudoType], { properties: [] }, cb);
    }
    getInheritedRules(element, cb) {
        this.callSuggestedBackendCbMethod(element, 'getInheritedRules', [], { rules: [] }, cb);
    }
    replaceStyleSheetAllProperties(sheetIndex, ruleIndex, inlineStyle, callback) {
        const { _backendContext } = this;
        if (!_backendContext.replaceStyleSheetAllProperties) {
            callback(null);
            return;
        }
        _backendContext.replaceStyleSheetAllProperties(sheetIndex, ruleIndex, inlineStyle, callback);
    }
    getBoundingClientRect(element, cb) {
        element.getBoundingClientRect(cb);
    }
    getBoxModel(element, cb) {
        const mockRect = { left: 0, top: 0, width: 0, height: 0 };
        const mockBoxModel = {
            margin: mockRect,
            border: mockRect,
            padding: mockRect,
            content: mockRect,
        };
        this.callSuggestedBackendCbMethod(element, 'getBoxModel', [], mockBoxModel, cb);
    }
    getMatchedRules(element, cb) {
        this.callSuggestedBackendCbMethod(element, 'getMatchedRules', [], { inline: [], rules: [] }, cb);
    }
    getScrollOffset(element, cb) {
        element.getScrollOffset(cb);
    }
    setScrollPosition(element, scrollLeft, scrollTop, duration) {
        var _a, _b;
        const { _glassEasel } = this;
        const backendContext = element.getBackendContext();
        const backendElement = element.getBackendElement();
        if (!backendContext || !backendElement) {
            return;
        }
        if (backendContext.mode === 3 /* _glassEasel.BackendMode.Domlike */) {
            if (!backendContext.setScrollPosition) {
                return;
            }
            (_a = backendContext.setScrollPosition) === null || _a === void 0 ? void 0 : _a.call(backendContext, backendElement, scrollLeft, scrollTop, duration);
        }
        else {
            const be = backendElement;
            if (!be.setScrollPosition) {
                return;
            }
            (_b = be.setScrollPosition) === null || _b === void 0 ? void 0 : _b.call(be, scrollLeft, scrollTop, duration);
        }
    }
    getContext(element, cb) {
        this.callSuggestedBackendCbMethod(element, 'getContext', [], null, cb);
    }
    getPseudoTypes(element, cb) {
        this.callSuggestedBackendCbMethod(element, 'getPseudoTypes', [], [], cb);
    }
    startOverlayInspect(callback) {
        const { _backendContext } = this;
        if (!_backendContext.startOverlayInspect) {
            return;
        }
        _backendContext.startOverlayInspect(callback);
    }
    stopOverlayInspect() {
        const { _backendContext } = this;
        if (!_backendContext.stopOverlayInspect) {
            return;
        }
        _backendContext.stopOverlayInspect();
    }
    triggerNativeEvent(element, type, detail) {
        this.callSuggestedBackendMethod(element, 'triggerNativeEvent', [type, detail]);
    }
    manipulateNativeNode(element, action, args, callback) {
        this.callSuggestedBackendCbMethod(element, 'manipulateNativeNode', [action, args], null, callback);
    }
    getActiveElement(cb) {
        const { _backendContext } = this;
        if (!_backendContext.getActiveElement) {
            return cb(null);
        }
        _backendContext.getActiveElement(cb);
    }
    setListenerStats(element, type, capture, mutLevel, listener) {
        const { _glassEasel, _listenerMap } = this;
        const elemListenerMap = _listenerMap;
        if (!elemListenerMap.has(element))
            elemListenerMap.set(element, []);
        const listeners = elemListenerMap.get(element);
        const oldIndex = listeners.findIndex(({ name, isCapture }) => name === type && isCapture === capture);
        if (oldIndex !== -1) {
            const { listener: oldListener, isCapture: oldIsCapture } = listeners[oldIndex];
            listeners.splice(oldIndex, 1);
            element.removeListener(type, oldListener, { capture: oldIsCapture });
        }
        element.addListener(type, listener, {
            mutated: mutLevel === 1 /* _glassEasel.EventMutLevel.Mut */,
            final: mutLevel === 2 /* _glassEasel.EventMutLevel.Final */,
            capture,
        });
        listeners.push({ name: type, listener, isCapture: capture });
    }
    initValues(element, values) {
        initValues(element, values);
    }
    updateValues(element, changes) {
        updateValues(element, changes);
    }
    registerStyleSheetContent(path, content) {
        const { _backendContext } = this;
        _backendContext.registerStyleSheetContent(path, content);
    }
    appendStyleSheetPath(index, path, styleScope) {
        const { _backendContext, _styleSheetIdMapping, _styleScopeIdMapping } = this;
        const actualStyleScope = styleScope !== undefined ? _styleScopeIdMapping[styleScope] : undefined;
        const styleSheetIndex = _backendContext.appendStyleSheetPath(path, actualStyleScope);
        _styleSheetIdMapping[index] = styleSheetIndex;
    }
    disableStyleSheet(index) {
        const { _backendContext, _styleSheetIdMapping } = this;
        const styleSheetIndex = _styleSheetIdMapping[index];
        _backendContext.disableStyleSheet(styleSheetIndex);
    }
    performanceStartTrace(index) {
        this._traceStartTimestampMapping[index] = Date.now();
    }
    performanceEndTrace(index, cb) {
        const endTimestamp = Date.now();
        const startTimestamp = this._traceStartTimestampMapping[index];
        delete this._traceStartTimestampMapping[index];
        cb({ startTimestamp, endTimestamp });
    }
    handleCustomMethod(_element, _options) {
        // To be override
    }
    onCustomMethod(handler) {
        this._customMethodHandler = handler;
    }
    sendCustomMethod(element, options) {
        var _a;
        (_a = this._customMethodHandler) === null || _a === void 0 ? void 0 : _a.call(this, element, options);
    }
    setDynamicSlotHandler(handler) {
        this._dynamicSlotHandler = handler;
    }
}
export { ChannelEventType, MessageChannelViewSide, getNodeId } from './message_channel';
//# sourceMappingURL=view_controller.js.map